'use client';

import React, { createContext, useContext } from 'react';
import { Experiments } from '@/domain/experiments';

interface ExperimentsContextValue {
  experiments: Experiments;
  hasAffiliateRef: boolean;
}

const ExperimentsContext = createContext<ExperimentsContextValue>({
  experiments: {},
  hasAffiliateRef: false,
});

export const useExperiments = () => useContext(ExperimentsContext);

export function ExperimentsProvider({
  experiments,
  hasAffiliateRef,
  children,
}: ExperimentsContextValue & { children: React.ReactNode }) {
  return <ExperimentsContext.Provider value={{ experiments, hasAffiliateRef }}>{children}</ExperimentsContext.Provider>;
}
